import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Clock, Users, Palette, HeartHandshake } from 'lucide-react';

const About = () => {
    const { t, isRTL } = useLanguage();

    const stats = [
        { icon: Clock, label: t.about.experience, color: 'text-mid-purple' },
        { icon: Users, label: t.about.clients, color: 'text-mid-green' },
        { icon: Palette, label: t.about.designs, color: 'text-light-pink' },
        { icon: HeartHandshake, label: t.about.trust, color: 'text-blue-400' },
    ];

    return (
        <section id='about' className='relative bg-black py-24 overflow-hidden'>
            {/* Decorative Background */}
            <div className='top-0 right-0 absolute bg-mid-purple/5 blur-3xl rounded-full w-96 h-96' />
            <div className='bottom-0 left-0 absolute bg-light-pink/5 blur-3xl rounded-full w-80 h-80' />

            <div className='z-10 relative mx-auto px-4 lg:px-8 max-w-6xl'>
                <div className='items-center gap-16 grid lg:grid-cols-2'>
                    {/* Image Side */}
                    <div className='group relative'>
                        <div className='relative rounded-lg overflow-hidden'>
                            <img
                                src='aboutimg.jpeg'
                                alt='Raz at work'
                                className='w-full h-[500px] object-cover group-hover:scale-105 transition-transform duration-700'
                            />
                            <div className='absolute inset-0 bg-gradient-to-t from-black/60 to-transparent' />
                        </div>
                        {/* Floating Badge */}
                        <div className='-right-6 lg:right-auto -bottom-6 lg:-left-6 absolute bg-mid-purple shadow-xl px-6 py-4 rounded-lg text-black'>
                            <span className='text-sm uppercase tracking-wider'>
                                Est. 2018
                            </span>
                        </div>
                    </div>

                    {/* Content Side */}
                    <div className='space-y-8'>
                        <div>
                            <span className='text-mid-purple text-sm uppercase tracking-[0.2em]'>
                                {isRTL ? 'הכירו אותי' : 'Meet The Artist'}
                            </span>
                            <h2 className='mt-4 font-display text-white text-4xl lg:text-5xl uppercase'>
                                {t.about.title}
                            </h2>
                        </div>

                        <p className='text-mid-grey text-lg leading-relaxed'>
                            {t.about.description}
                        </p>

                        {/* Stats */}
                        <div className='gap-6 grid grid-cols-1 sm:grid-cols-3 pt-6'>
                            {stats.map((stat, index) => {
                                const isLastAlone =
                                    stats.length % 3 === 1 &&
                                    index === stats.length - 1;

                                return (
                                    <div
                                        key={index}
                                        className={`group bg-white/5 hover:bg-white/10 p-6 border border-white/10 hover:border-light-pink/30 rounded-lg transition-all duration-300 ${
                                            isLastAlone ? 'sm:col-span-3' : ''
                                        }`}
                                    >
                                        <stat.icon
                                            className={`w-8 h-8 ${stat.color} mb-4`}
                                        />
                                        <p className='font-medium text-white text-sm'>
                                            {stat.label}
                                        </p>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
